














































import { Component, Vue, Prop } from 'vue-property-decorator';
import { UserModule } from '@/store/modules/user';

@Component({
  name: 'countryDistributionBar',
})
export default class extends Vue {
  @Prop({ default: [] }) public data!: any;
  @Prop({ default: 1 }) public num!: number;

  get institutionName() {
    return `${this.data.institutionName}`
  }

  get year() {
    return UserModule.indexSelectYear;
  }
  public getImageUrl(index: number) {
    try {
      return require('@/assets/image/common/top9/' + String(index) + '.png');
    } catch(err) {
      return '';
    }
  }

  public linkTo(name: string, isEnrol = false) {
    const year = this.year;
    if (year !== '0') {
      const endTime = `${year}-12-${new Date(Number(year), 12, 0).getDate()}`;
      const startTime = `${year}-1-1`
      const ctryId = this.data.fkAreaCountryId;
      const ctry = this.data.areaCountryName;
      const schId = this.data.fkInstitutionId;
      const sch = this.data.institutionName;
      if (isEnrol) {
        this.$router.push({ name, query: { startTime: startTime.toString(), endTime: endTime.toString(), ctryId, ctry, schId, sch, stepId: 8+'' } })
      } else {
        this.$router.push({ name, query: { startTime: startTime.toString(), endTime: endTime.toString(), ctryId, ctry, schId, sch } })
      }
    } else {
      this.$message.warning(this.$t('message.businessOverviewMessage') as string);
    }
  }
}
